module.exports = __webpack_public_path__ + "static/media/grim-reaper.92ae0d84.svg";